var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-4",attrs:{"width":"100%","outlined":""}},[_c('apexchart',{attrs:{"height":"400px","type":"donut","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }